import type { TextureManager } from '../../../managers/texture-manager';
import type { ModelManager } from '../../../managers/model-manager';
import type { QualitySettings } from '../../../../hooks/use-three-kitchen/quality';

/**
 * Appliance configuration input
 */
export interface ApplianceInput {
	/** Unique identifier */
	id: string;
	/** SKU for model lookup */
	sku?: string;
	/** Model path (relative to base path) - alternative to sku */
	modelPath?: string;
	/** Size dimensions */
	size?: {
		width: number;
		height: number;
		depth: number;
	};
	/** Position */
	position?: { x: number; y: number; z: number };
	/** Rotation (radians) */
	rotation?: { x: number; y: number; z: number };
	/** Scale */
	scale?: number;
	/** Appliance type/category */
	type?: string;
	/** Placement type */
	placement?: string;
}

/**
 * Configuration for ApplianceSceneBuilder
 */
export interface ApplianceSceneBuilderConfig {
	/** Base path for assets */
	basePath: string;
	/** Render quality (0-10) */
	renderQuality: number;
	/** Quality settings */
	qualitySettings: QualitySettings | null;
	/** Texture manager reference */
	textureManager: TextureManager | null;
	/** Model manager reference */
	modelManager: ModelManager | null;
}

/**
 * Default configuration
 */
export const DEFAULT_APPLIANCE_CONFIG: ApplianceSceneBuilderConfig = {
	basePath: '',
	renderQuality: 7,
	qualitySettings: null,
	textureManager: null,
	modelManager: null
};
